export default __webpack_public_path__ + "static/7-7c1df7068c83a63b3c22adcbaf5fe33c.png";